import * as React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// context
import { ObjectSecurityContext } from 'containers/Security/components/ObjectSecurity/layers/API'
// constants
import { Forms } from 'constants/index'
import { Modals } from 'constants/modals'
// components
import DeleteButton from 'components/Modals/GroupSecurityModal/Form/BusinessRule/components/DeleteButton'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import { ReduxEntitySelect, ReduxInput, ReduxSwitch } from 'components/FormElements/ReduxForm'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// graphql
import { OBJECT_ENTITIES_SELECT_QUERY } from 'graphql/objects/queries'
import { SECURITY_PROFILES_SELECT_QUERY } from 'graphql/securityProfiles/queries'
// views
import { BottomPaper, Form, Scrollbar } from 'themes/views/security'
// types
import { IOption } from 'components/FormElements/Select'
import { IObjectSecurity } from 'types/graphql'
// utils
import { required } from 'utils/index'
import { objectsProps, securityProfileProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

// types
interface IIncomingProps {
  hideModal: () => void
  isEdit: boolean
  objectSecurity: IObjectSecurity
}

const ObjectSecurityCreateForm: React.FC<InjectedFormProps & IIncomingProps> = ({
  handleSubmit,
  hideModal,
  isEdit,
  objectSecurity,
  submitting
}) => {
  const { companyId, deleteObjectSecurity } = React.useContext(ObjectSecurityContext)

  const { showModal: showConfirmModal } = useShowModal({ modalType: Modals.CONFIRM_DELETE_MODAL })

  const handleDeleteObjectSecurity = () =>
    showConfirmModal({ handleConfirm: () => deleteObjectSecurity(objectSecurity.id, hideModal) })

  const prepareOptions = (options: IOption[]) => options.filter((option) => option.label !== 'Resource')

  return (
    <Form onSubmit={handleSubmit} data-testid='object-security-form'>
      <Scrollbar>
        {isEdit && <DeleteButton iconSize={24} handleOnClick={handleDeleteObjectSecurity} />}
        <ReduxSwitch label={'Active'} name={'active'} reverse />
        <ReduxInput label={'Name'} name={'name'} validate={[required]} />
        <ReduxEntitySelect
          prepareOptions={prepareOptions}
          label={'Object'}
          name={'object'}
          query={OBJECT_ENTITIES_SELECT_QUERY}
          validate={[required]}
          {...objectsProps}
        />
        <ReduxInput label={'Description'} multiline name={'description'} validate={[required]} />
        <ReduxEntitySelect
          key={companyId}
          isMultiple
          label={'Profiles'}
          name={'profiles'}
          query={SECURITY_PROFILES_SELECT_QUERY}
          variables={{ filter: { companyId } }}
          validate={[required]}
          {...securityProfileProps}
        />
      </Scrollbar>

      <BottomPaper square>
        <Button type={'submit'} layout={BUTTON_LAYOUTS.PURPLE} isLoading={submitting}>
          {isEdit ? 'Save' : 'Create'}
        </Button>
        <Button layout={BUTTON_LAYOUTS.WHITE} type={'button'} onClick={hideModal}>
          Cancel
        </Button>
      </BottomPaper>
    </Form>
  )
}

export default reduxForm<any, any>({
  form: Forms.OBJECT_SECURITY_CREATE_FORM,
  enableReinitialize: true
})(ObjectSecurityCreateForm)
